'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.testForCssVars = testForCssVars;
var body = document.body || document.documentElement;

function hasNativeCSSProperties() {
  var opacity = '0';
  var el = body;
  // Setup CSS properties.
  el.style.setProperty('--test-opacity', opacity);
  el.style.setProperty('opacity', 'var(--test-opacity)');
  // Feature detect then remove all set properties.
  var hasNativeCSSProperties = window.getComputedStyle(el).opacity === opacity;
  el.style.setProperty('--test-opacity', '');
  el.style.opacity = '';
  return hasNativeCSSProperties;
}

function testForCssVars() {
  if (hasNativeCSSProperties() === false) {
    require('./css-vars');
    body.className += ' util-NoCssVars';
  }
}